module.exports = __webpack_public_path__ + "assets/events_threat_primary.66cede08.svg";